import CreditCard from "components/CreditCardManagement/CreditCard";
import { useEffect, useState } from "react";
import "../components/CreditCardManagement/credit-card.scss";
import Pagination from "rc-pagination";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Title from "common/Title";
import { BsCreditCard2Front } from "react-icons/bs";
import sendRequest from "hooks/useAxios";

import Loader from "utils/Loader";
import { toast } from "react-toastify";
import toastFunction from "utils/toast";
import logo from "assets/images/sitelogo.svg";
import { Helmet } from "react-helmet";

export default function CreditCardManagement({ logo }) {
  const [creditCardListWaiting, setCreditCardListWaiting] = useState([
    { user_info: [], card: {} },
  ]);
  const [creditCardAll, setCreditCardAll] = useState([
    { user_info: [], card: {} },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [listUpdater, setListUpdater] = useState(false);
  const [currentPageTab1, setCurrentPageTab1] = useState(1);
  const [currentPageTab2, setCurrentPageTab2] = useState(1);
  const activeOrDeactive = (type, id) => {
    let temp = "";
    if (type == "active") {
      temp = 3;
    } else {
      temp = 0;
    }

    sendRequest("Update_cards", {
      conditions: `id/=/${id}`,
      keyvalues: `status,${temp}`,
    }).then((data) => {
      if (data.data.status == 1) {
        if (type == "active") {
          toastFunction("success", "کارت با موفقیت تایید شد.");
        } else if (type == "deactive") {
          toastFunction("success", "کارت موردنظر رد شد.");
        }
        setListUpdater((prev) => !prev);
      } else {
        if (type == "active") {
          toastFunction("success", " مشکلی در تایید کارت به وجود آمده است.");
        } else if (type == "deactive") {
          toastFunction("success", " مشکلی در رد کارت به وجود آمده است.");
        }
      }
    });
  };
  useEffect(() => {
    // setIsLoading(true);
    async function LoadPage() {
      await sendRequest("get_bankcard").then((data) => {
        setCreditCardListWaiting(
          data.data.data.filter((f) => f.card.status == "1")
        );
        setCreditCardAll(data.data.data.filter((f) => f.card.status != "1"));
      });
      setIsLoading(false);
    }
    LoadPage();
  }, [listUpdater]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`مدیریت کارت بانکی`} </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      {isLoading && <Loader />}
      <div>
        <Title
          color="rgb(244 124 96)"
          title="مدیریت کارتهای بانکی"
          icon={BsCreditCard2Front}
        />

        <div className="credit-card-management mx-auto ">
          <Tabs defaultActiveKey="all">
            <Tab eventKey="all" title="همه">
              <div>
                {creditCardAll.length > 0 ? (
                  creditCardAll
                    ?.slice(
                      (currentPageTab1 - 1) * 10,
                      (currentPageTab1 - 1) * 10 + 10
                    )
                    .map((value, index) => {
                      return (
                        <div className="my-4">
                          <CreditCard
                            data={value}
                            index={index}
                            type="accept"
                          />
                        </div>
                      );
                    })
                ) : (
                  <p className="text-center mt-3">
                    در حال حاضر کارت تایید شده ای وجود ندارد.
                  </p>
                )}
              </div>
              <div className="text-center">
                <Pagination
                  pageSize={10}
                  current={currentPageTab1}
                  total={creditCardAll.length}
                  showLessItems={true}
                  hideOnSinglePage={true}
                  onChange={(page) => setCurrentPageTab1(page)}
                />
              </div>
            </Tab>
            <Tab eventKey="waiting" title="در انتظار تایید">
              <div>
                {creditCardListWaiting.length > 0 ? (
                  creditCardListWaiting
                    ?.slice(
                      (currentPageTab2 - 1) * 10,
                      (currentPageTab2 - 1) * 10 + 10
                    )
                    .map((value, index) => {
                      return (
                        <div className="my-4">
                          <CreditCard
                            data={value}
                            index={index}
                            activeOrDeactive={activeOrDeactive}
                          />
                        </div>
                      );
                    })
                ) : (
                  <p className="text-center mt-3">
                    در حال حاضر کارتی برای تایید وجود ندارد.{" "}
                  </p>
                )}
              </div>
              <div className="text-center">
                <Pagination
                  pageSize={10}
                  current={currentPageTab2}
                  total={creditCardListWaiting.length}
                  onChange={(page) => setCurrentPageTab2(page)}
                  showLessItems={true}
                  hideOnSinglePage={true}
                />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}
